// extracted by mini-css-extract-plugin
export default {"benefitsContainer":"benefits_benefitsContainer__-PMxg","tabList":"benefits_tabList__aWOQ2","tab":"benefits_tab__aUIag","active":"benefits_active__aVp+n"};